(() => {
  'use strict';
  const config = document.querySelector('[data-mewo-review-photo-order]');
  if (!config || config.dataset.started) return;
  config.dataset.started = 'true';
  let category = config.dataset.category;
  const collectionCategories = {
    'custom-birthday-temporary-tattoos': 'birthdays',
    'custom-logo-temporary-tattoos': 'logos-artwork',
    'custom-wedding-temporary-tattoos': 'weddings',
    'custom-bachelorette-temporary-tattoos': 'bachelorette',
    'custom-kids-birthday-temporary-tattoos': 'kids-birthdays',
    'custom-pet-temporary-tattoos': 'pets',
    'custom-text-temporary-tattoos': 'custom-text',
    'custom-graduation-temporary-tattoos': 'graduation'
  };
  if (location.pathname.includes('/products/') && document.referrer) {
    try {
      const source = new URL(document.referrer);
      const collection = source.pathname.match(/\/collections\/([^/]+)\/?$/)?.[1];
      if (source.origin === location.origin && collectionCategories[collection]) category = collectionCategories[collection];
    } catch (_) {}
  }
  const known = new Set(['birthdays', 'logos-artwork', 'weddings', 'bachelorette', 'kids-birthdays', 'pets', 'custom-text', 'graduation']);
  if (!known.has(category)) return;
  const finished = new WeakSet();
  let mapping;
  const photoKey = value => {
    try {
      return new URL(value, location.href).pathname.split('/').pop()
        .replace(/\.(png|jpe?g|webp)$/i, '').split('__')
        .map(part => part.replace(/^_+/, ''))
        .filter(part => !['small', 'compact', 'huge', 'original'].includes(part))
        .slice(-2).join('__');
    } catch (_) { return ''; }
  };
  const metadata = (review, picture) => mapping.photos[photoKey(picture.huge || picture.original || picture.compact)] || mapping.reviews[review.uuid];
  const rank = review => review.pictures_urls.some(picture => metadata(review, picture)?.category === category) ? 0 : 1;
  const readReview = element => {
    const text = selector => element.querySelector(selector)?.textContent || '';
    const html = selector => element.querySelector(selector)?.innerHTML || '';
    const attr = (selector, attribute) => element.querySelector(selector)?.getAttribute(attribute);
    const pictures = Array.from(element.querySelectorAll('.jdgm-rev__pic-link:not(.jdgm-rev__product-picture)')).map(link => ({
      compact: link.querySelector('.jdgm-rev__pic-img')?.getAttribute('data-src') || link.querySelector('img')?.getAttribute('src'),
      huge: link.getAttribute('data-mfp-src') || link.getAttribute('href'),
      original: link.getAttribute('href')
    })).filter(picture => picture.compact && picture.huge);
    return {
      uuid: element.getAttribute('data-review-id'),
      language: element.getAttribute('data-review-language'),
      rating: Number(attr('.jdgm-rev__rating', 'data-score')),
      created_at: attr('.jdgm-rev__timestamp', 'data-content'),
      reviewer_name: text('.jdgm-rev__author'),
      title: html('.jdgm-rev__title'),
      body_html: html('.jdgm-rev__body'),
      verified_buyer: element.getAttribute('data-verified-buyer') === 'true',
      product_title: element.getAttribute('data-product-title'),
      product_url: element.getAttribute('data-product-url'),
      country_code_show_flag: attr('.jdgm-rev__location', 'data-country-code'),
      location: text('.jdgm-rev__location'),
      gravatar_hash: attr('.jdgm-rev__icon', 'data-gravatar-hash'),
      pictures_urls: pictures,
      video_external_ids: [],
      video_external_data: {},
      media_platform_hosted_video_infos: [],
      cf_answers: []
    };
  };
  const fetchPublishedMedia = async (jdgm, widget, state) => {
    const endpoint = new URL(state.url, jdgm.API_HOST.replace(/\/$/, '') + '/');
    if (!['judge.me', 'api.judge.me'].includes(endpoint.hostname) || endpoint.pathname !== '/reviews/reviews_for_widget') throw new Error('Unsupported gallery source');
    const params = jdgm.ajaxParamsFor(widget);
    Object.entries(params).forEach(([key, value]) => { if (value != null) endpoint.searchParams.set(key, String(value)); });
    endpoint.searchParams.set('review_type', 'all-reviews');
    endpoint.searchParams.set('sort_by', 'with_media');
    endpoint.searchParams.set('per_page', '10');
    const reviews = new Map();
    for (let page = 1; page <= 20; page++) {
      endpoint.searchParams.set('page', String(page));
      const response = await fetch(endpoint, {credentials: 'omit', signal: AbortSignal.timeout(12000)});
      if (!response.ok) throw new Error('Gallery unavailable');
      const payload = await response.json();
      if (typeof payload.html !== 'string') throw new Error('Unsupported gallery response');
      const parsed = new DOMParser().parseFromString(payload.html, 'text/html');
      const elements = Array.from(parsed.querySelectorAll('.jdgm-rev'));
      if (elements.some(element => element.querySelector('.jdgm-vid-player, .jdgm-yt-video'))) throw new Error('Use native gallery for video reviews');
      elements.forEach(element => {
        const review = readReview(element);
        if (review.uuid && review.pictures_urls.length) reviews.set(review.uuid, review);
      });
      if (elements.length < 10) return {reviews: Array.from(reviews.values()), page};
    }
    throw new Error('Use native pagination for larger galleries');
  };
  const enhance = async gallery => {
    const jdgm = window.jdgm;
    const $ = jdgm?.$;
    if (!$ || !jdgm.ajaxParamsFor || !jdgm.templates?.photoGalleryThumbnail) return false;
    const native = $(gallery);
    const state = native.data('gallery-data');
    const options = native.find('.jdgm-gallery__thumbnail-link').first().data('magnificPopup');
    if (!state?.reviews || !options || finished.has(gallery)) return false;
    finished.add(gallery);
    gallery.dataset.mewoOrdering = 'loading';
    try {
      mapping ||= fetch(config.dataset.mapUrl).then(response => {
        if (!response.ok) throw new Error('Category map unavailable');
        return response.json();
      });
      mapping = await mapping;
      const result = await fetchPublishedMedia(jdgm, native.closest('.jdgm-widget'), state);
      if (!result.reviews.length || !gallery.isConnected) throw new Error('No published photos');
      const ordered = result.reviews.map((review, index) => ({review, index})).sort((a, b) => rank(a.review) - rank(b.review) || a.index - b.index);
      const seen = new Set();
      const reviews = {};
      ordered.forEach(({review}) => {
        review.pictures_urls = review.pictures_urls.filter(picture => {
          const key = metadata(review, picture)?.id || photoKey(picture.huge);
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        if (review.pictures_urls.length) reviews[review.uuid] = review;
      });
      const popup = $.magnificPopup?.instance;
      if (popup?.isOpen) {
        gallery.dataset.mewoOrdering = 'deferred';
        finished.delete(gallery);
        return true;
      }
      const fragment = document.createDocumentFragment();
      Object.values(reviews).forEach(review => {
        const template = document.createElement('template');
        template.innerHTML = jdgm.templates.photoGalleryThumbnail({review, preload: true});
        template.content.querySelectorAll('.jdgm-gallery__thumbnail-link').forEach(link => {
          link.setAttribute('role', 'button');
          link.setAttribute('tabindex', '0');
          link.setAttribute('aria-label', `View ${review.reviewer_name || 'customer'} review photo`);
          link.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); link.click(); }
          });
        });
        fragment.append(template.content);
      });
      native.data('gallery-data', {...state, reviews, perPage: 10, page: result.page, fetching: false, canNotFetch: true});
      gallery.replaceChildren(fragment);
      native.find('.jdgm-gallery__thumbnail-link').magnificPopup({...options, items: native.find('.jdgm-gallery__thumbnail').toArray()});
      jdgm.setupLazyLoadPicture(native.find('.jdgm-gallery__thumbnail'));
      gallery.dataset.mewoOrdering = 'ready';
      gallery.dataset.mewoCategory = category;
      gallery.dataset.mewoPhotoCount = String(seen.size);
    } catch (_) {
      gallery.dataset.mewoOrdering = 'native-fallback';
    }
    return true;
  };
  let queued = false;
  const scan = () => {
    queued = false;
    if (window.jdgm?.$?.magnificPopup?.instance?.isOpen) return;
    document.querySelectorAll('.jdgm-widget .jdgm-gallery').forEach(gallery => { if (!finished.has(gallery)) enhance(gallery); });
  };
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  });
  observer.observe(document.querySelector('main') || document.getElementById('MewoMain') || document.body, {childList: true, subtree: true});
  scan();
  window.addEventListener('load', scan, {once: true});
  document.addEventListener('click', event => {
    if (event.target.closest?.('.jm-mfp-close, .jm-mfp-bg')) requestAnimationFrame(scan);
  });
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape') requestAnimationFrame(scan);
  });
})();
